import { get, post } from "./api";

export const getProduct = (id) => {
  const url = `/api/experience/v1/products/${id}`;
  return get({ url }).then((response) => {
    return response.data.data;
  });
};

export const getListProduct = async (listID) => {
  const request = listID.map(async (item) => {
    return await getProduct(item);
  });
  const result = await Promise.all(request);
  return result;
};

export const getAllProductList = async (list) => {
  const request = list.map(async (item) => {
    return await getListProduct(item);
  });
  const result = await Promise.all(request);
  return result;
};

export const searchProducts = async (params) => {
  const url = `/api/experience/v1/products/`;
  return get({ url, params }).then((response) => {
    return response.data;
  });
};

export const getListCity = async (params) => {
  const url = `/api/experience/v1/places/cities`;
  return get({ url, params }).then((response) => {
    return response.data.data;
  });
};

export const getListCountries = async () => {
  const url = `/api/experience/v1/places/countries`;
  return get({ url }).then((response) => {
    return response.data.data;
  });
};

export const getDetailProduct = async (id) => {
  const url = `/api/experience/v1/products/${id}`;
  return get({ url }).then((response) => {
    return response.data.data;
  });
};

export const getDetailTicket = async (id) => {
  const url = `/api/experience/v1/products/ticket_types/${id}`;
  return get({ url }).then((response) => {
    return response.data.data;
  });
};

export const getCountryList = async () => {
  const url = `/api/experience/v1/places/countries`;
  return get({ url }).then((response) => {
    return response.data.data;
  });
};

export const getTIIMPrice = async (headersAuthen, userCode, params) => {
  const url = `/api/v1/exchange/tiim_price?to=USD`;
  return get({ url, headersAuthen, userCode, params }).then((response) => {
    return response.data.data;
  });
};

export const createBooking = async (data, headersAuthen, userCode) => {
  const url = `/api/experience/v1/transactions`;
  return post({ url, data, headersAuthen, userCode }).then((response) => {
    return response.data.data;
  });
};

export const getUserWallet = async (headersAuthen, userCode) => {
  const url = `/api/v1/me/wallets`;
  return get({ url, headersAuthen, userCode }).then((response) => {
    return response.data.data;
  });
};

export const checkProfile = async (headersAuthen, userCode) => {
  const url = `/api/v1/me`;
  return get({ url, headersAuthen, userCode }).then((response) => {
    return response.data.data;
  });
};

